import React from 'react';
import styled from 'styled-components';
import ReferenceContent from '../layout/ReferenceContent';

export default function Reference() {
  return (
    <PageWrapper>
      <h1>Reference</h1>
      <ReferenceContent />
    </PageWrapper>
  );
}

const PageWrapper = styled.div`
  padding: 24px 0;
`;
